import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { FormProvider } from './context/FormContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import PublicFormView from './pages/PublicFormView';

// Import pages (to be created)
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const FormBuilder = React.lazy(() => import('./pages/FormBuilder'));
const FormPreview = React.lazy(() => import('./pages/FormPreview'));
const FormResponses = React.lazy(() => import('./pages/FormResponses'));
const LandingPage = React.lazy(() => import('./pages/LandingPage'));

// Auth pages
const Login = React.lazy(() => import('./pages/Login'));
const Register = React.lazy(() => import('./pages/Register'));
const ForgotPassword = React.lazy(() => import('./pages/ForgotPassword'));

function App() {
  return (
    <AuthProvider>
      <FormProvider>
        <Router>
          <React.Suspense fallback={
            <div className="flex items-center justify-center h-screen">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
            </div>
          }>
            <Routes>
              {/* Auth routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              
              {/* Landing page - accessible to anyone */}
              <Route path="/" element={<LandingPage />} />
              
              {/* Public form route - no authentication required */}
              <Route path="/f/:formId" element={<PublicFormView />} />
              
              {/* Protected routes */}
              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/form/new" element={<FormBuilder />} />
                <Route path="/form/:formId" element={<FormBuilder />} />
                <Route path="/form/:formId/responses" element={<FormResponses />} />
              </Route>
              
              {/* Public routes */}
              <Route path="/form/:formId/preview" element={<FormPreview />} />
            </Routes>
          </React.Suspense>
        </Router>
      </FormProvider>
    </AuthProvider>
  );
}

export default App;
